import { DocPerClaimTypeGetUseCase } from '../../../application';

export default class DocPerClaimTypeGetService {
    constructor() {}

    async execute(event) {
        const request = await DocPerClaimTypeGetUseCase(event);

        return request;
    }
}
